<div class="container">
    <h2>
        Email delivery report
    </h2>

    <form [formGroup]="form" class="inputs">
        <mat-form-field appearance="fill" size>
            <mat-label>Date From</mat-label>
            <input matInput [matDatepicker]="pickerFrom" formControlName="dateFrom" placeholder="DD/MMM/YYYY" />
            <mat-datepicker-toggle matPrefix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
            <button mat-icon-button matSuffix (click)="clearDate('dateFrom')" *ngIf="form.get('dateFrom')?.value">
                <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="form.get('dateFrom')?.hasError('required') && form.get('dateFrom')?.touched">
                Start date is required
            </mat-error>
            <mat-error *ngIf="form.get('dateFrom')?.hasError('matDatepickerParse') && form.get('dateFrom')?.touched">
                Invalid date format
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Date To</mat-label>
            <input matInput [matDatepicker]="pickerTo" formControlName="dateTo" placeholder="DD/MMM/YYYY" />
            <mat-datepicker-toggle matPrefix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
            <button mat-icon-button matSuffix (click)="clearDate('dateTo')" *ngIf="form.get('dateTo')?.value">
                <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="form.get('dateTo')?.hasError('required') && form.get('dateTo')?.touched">
                End date is required
            </mat-error>
            <mat-error *ngIf="form.get('dateTo')?.hasError('matDatepickerParse') && form.get('dateTo')?.touched">
                Invalid date format
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Account</mat-label>
            <input matInput formControlName="account"/>
            <button mat-icon-button matSuffix (click)="clearAccount()" *ngIf="form.get('account')?.value">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" multiple (selectionChange)="onCountryChange()">
                <mat-select-trigger>
                    {{ selectedRolesDisplay('country') }}
                </mat-select-trigger>
                <mat-option *ngFor="let country of countries" [value]="country" [disabled]="isCountryDisabled(country)">{{ country }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('country')?.hasError('required') && form.get('country')?.touched">
                Country is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Delivery Status</mat-label>
            <mat-select formControlName="deliveryStatus" multiple (selectionChange)="onStatusChange()">
                <mat-select-trigger>
                    {{ selectedRolesDisplay('deliveryStatus') }}
                </mat-select-trigger>
                <mat-option *ngFor="let status of deliveryStatuses" [value]="status" [disabled]="isStatusDisabled(status)">{{ status }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('deliveryStatus')?.hasError('required') && form.get('deliveryStatus')?.touched">
                Delivery Status is required
            </mat-error>
        </mat-form-field>

        <div *ngIf="form.hasError('dateRangeInvalid') && (form.get('dateFrom')?.touched || form.get('dateTo')?.touched)">
            <mat-error style="margin-bottom: 2%;">'Date From' must be before or equal to 'Date To'</mat-error>
        </div>

    </form>

    <section class="buttons">
        <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="search()">
            Search
        </button>

        <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="onDownload()">
            Download
        </button>
    </section>

    <section class="progress-container">
        <div class="progress-label">
            <div>{{deliveredPercent}}%</div>
            <div>{{failedPercent}}%</div>
        </div>

        <div class="progress-bar">
            <div class="delivered" #delivered [title]="deliveredTitle"></div>
            <div class="failed" #failed [title]="failedTitle"></div>
        </div>

        <div class="legend">
            <div class="legend-item">
                <span class="legend-color delivered-color"></span>
                Delivered
            </div>
            <div class="legend-item">
                <span class="legend-color failed-color"></span>
                Failed
            </div>
        </div>
    </section>

    <section>
        <dl-email-delivery-table [emailTableData]="emailTableData"></dl-email-delivery-table>
    </section>
</div>